import { Form, Flex, Combobox, Input, Button } from '@zillow/constellation';
import React from 'react';
import { useTheme } from 'styled-components';

var AgentSearch = function AgentSearch(_ref) {
  var placeholder = _ref.placeholder,
    search = _ref.search,
    disabled = _ref.disabled;
  var theme = useTheme();
  var zip = '';
  var handleSelectChange = function handleSelectChange(item) {
    if (search === 'installations' && item) {
      zip = INSTALLATIONS.find(function (inst) {
        return inst[0] === item;
      })[1];
    }
  };
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    var form = event.target;
    var url = 'https://www.zillow.com/professionals/relocation--real-estate-agent-reviews/' + zip;
    form.action = url;
    form.submit();
  };

  // TODO: Replace with imorted military installations combobox component.
  // TODO: Get relationship between zip code and installation from ZG Graph
  var INSTALLATIONS = [['Fort Novosel', '36362'], ['Portsmouth Naval Shipyard', '03904'], ['Camp Pendleton', '92055']];
  var INSTALLAIONS_NAMES = INSTALLATIONS.map(function (inst) {
    return inst[0];
  });
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit,
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    flexDirection: "column"
  }, search === 'installations' ? /*#__PURE__*/React.createElement(Combobox, {
    options: INSTALLAIONS_NAMES,
    placeholder: placeholder,
    "aria-label": "installations",
    name: "installations",
    onChange: handleSelectChange,
    disabled: disabled ? 'disabled' : undefined
  }) : /*#__PURE__*/React.createElement(Input, {
    type: "text",
    "aria-label": "zipcode",
    name: "zipcode",
    placeholder: placeholder,
    disabled: disabled ? 'disabled' : undefined,
    onChange: function onChange(event) {
      return zip = event.target.value;
    }
  }), /*#__PURE__*/React.createElement(Button, {
    buttonType: "primary",
    disabled: disabled ? 'disabled' : undefined,
    style: {
      width: '100%',
      marginTop: theme.constellation.spacing.md
    }
  }, "Find an agent")));
};
var AgentSearch$1 = AgentSearch;

export { AgentSearch$1 as default };
